module.exports = "https://bin.bnbstatic.com/_next/static/images/dark-create-account-b38aa16a6bddb4ce3576755c46082e1a.svg";